import type {
  FiltrosUsuario,
  NivelAcesso,
  Usuario,
  UsuarioFormValues,
} from "../../types/UsuarioTypes";

// Ajuste conforme sua configuração de ambiente (ex: import.meta.env.VITE_API_URL)
const API_BASE = process.env.REACT_APP_API ?? "";
const RESOURCE = `${API_BASE}/api/Usuario`;

// Mesma chave usada pelo authSlice.setToken — se algum dia mudar lá, muda aqui também.
function getTokenAtual(): string | null {
  return localStorage.getItem("token");
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = getTokenAtual();

  const response = await fetch(`${RESOURCE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  });

  const rawText = await response.text();
  const data = rawText ? safeJsonParse(rawText) : null;

  if (!response.ok) {
    const mensagem =
      typeof data === "string" ? data : (data as { message?: string })?.message;
    throw new Error(mensagem || "Não foi possível concluir a operação");
  }

  return data as T;
}

function safeJsonParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

function montarQueryString(filtros: FiltrosUsuario): string {
  const params = new URLSearchParams();
  Object.entries(filtros).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") {
      params.append(chave, String(valor));
    }
  });
  return params.toString();
}

export const usuarioService = {
  listar(filtros: FiltrosUsuario = {}): Promise<Usuario[]> {
    const qs = montarQueryString(filtros);
    return request<Usuario[]>(`/GetUsuariosAll${qs ? `?${qs}` : ""}`);
  },

  buscarPorId(id: number): Promise<Usuario> {
    return request<Usuario>(`/${id}`);
  },

  niveisAcesso(): Promise<NivelAcesso[]> {
    return request<NivelAcesso[]>("/GetNiveisAcesso");
  },

  criar(usuario: UsuarioFormValues): Promise<string> {
    return request<string>("", {
      method: "POST",
      body: JSON.stringify(usuario),
    });
  },

  atualizar(id: number, usuario: UsuarioFormValues): Promise<string> {
    return request<string>(`/${id}`, {
      method: "PUT",
      body: JSON.stringify(usuario),
    });
  },

  excluir(id: number): Promise<string> {
    return request<string>(`/Excluir/${id}`, { method: "PUT" });
  },

  reenviarAtivacao(id: number, usuario: Partial<Usuario>): Promise<string> {
    return request<string>(`/ResetUsuario/${id}`, {
      method: "PUT",
      body: JSON.stringify(usuario),
    });
  },

  resetarSenhaPadrao(id: number): Promise<string> {
    return request<string>(`/ResetSenhaPadrao/${id}`, { method: "PUT" });
  },

  ativarDesativar(id: number, ativar: boolean): Promise<string> {
    return request<string>(
      `/AtivarDesativarUsuario/${id}?setStatus=${ativar}`,
      {
        method: "PUT",
      },
    );
  },
};
